export const INTERNATIONAL_OFFER_ENABLED = true;

export const INTERNATIONAL_OFFER_CODE = 'INTERNATIONAL';
export const INTERNATIONAL_DISCOUNT_APP_PRODUCT = 'disc_international';

export const INTERNATIONAL_AREA_PRODUCT_ID = 'prod_RIiXjEJS0iWHyV';
export const INTERNATIONAL_AREA_PRICE_ID = 'price_1QQ76YEbt1PAjLH95ank9PHL';
export const INTERNATIONAL_TRAINING_PRODUCT_ID = 'prod_UxJjbJaNnAOiA1';
export const INTERNATIONAL_TRAINING_PRICE_ID = 'price_1TxP5sEbt1PAjLH9Pdg0QBMZ';
export const INTERNATIONAL_DISCOUNT_COUPON_ID = 'XkVQlSBJ';

export const INTERNATIONAL_CATALOGUES_PRICE = 1836;
export const INTERNATIONAL_TRAINING_PRICE = 150;
export const INTERNATIONAL_REGISTRATION_FEE_PRICE = 125;
export const INTERNATIONAL_REFERENCE_PRICE = 2111;
export const INTERNATIONAL_TOTAL_PRICE = 1986;
export const INTERNATIONAL_DISCOUNT_PERCENTAGE = 40;
export const INTERNATIONAL_FINAL_PRICE = 1191.6;

export const INTERNATIONAL_OFFER_AREAS = [
  'a_costa_blanca_calida',
  'a_costa_sol',
  'a_portugal',
  'a_georgia',
  INTERNATIONAL_DISCOUNT_APP_PRODUCT
];

export const INTERNATIONAL_OFFER_PLAN = {
  id: 902,
  stripeproductid: INTERNATIONAL_AREA_PRODUCT_ID,
  type: 'area',
  subtype: 'international-offer',
  code: INTERNATIONAL_OFFER_AREAS.join(','),
  codes: INTERNATIONAL_OFFER_AREAS,
  name: {
    es: 'HabiHub International',
    en: 'HabiHub International',
    pt: 'HabiHub International',
    ka: 'HabiHub International',
    ru: 'HabiHub International'
  },
  prices: {
    yearly: {
      tiers: [
        {
          price: INTERNATIONAL_FINAL_PRICE,
          lastUnit: 4,
          firstUnit: 0
        }
      ],
      priceId: INTERNATIONAL_AREA_PRICE_ID
    }
  }
};

type ParsedOffer = {
  name: string;
  activatedAt: number;
  duration: string;
  expiresAt: number;
  remainingMs: number;
  isActive: boolean;
};

const DURATION_PATTERN = /^(\d+)([HD])$/;

export function isInternationalContextCode(code?: string | null) {
  return (
    String(code || '')
      .trim()
      .toUpperCase() === INTERNATIONAL_OFFER_CODE
  );
}

export function parseInternationalOffer(offer?: string | null): ParsedOffer | null {
  if (!INTERNATIONAL_OFFER_ENABLED || !offer) return null;

  const [name, activatedAtValue, durationValue] = String(offer).split(';');
  const normalizedName = String(name || '')
    .trim()
    .toUpperCase();
  const activatedAt = Number(activatedAtValue);
  const duration = String(durationValue || '')
    .trim()
    .toUpperCase();
  const durationMatch = duration.match(DURATION_PATTERN);

  if (normalizedName !== INTERNATIONAL_OFFER_CODE || !Number.isFinite(activatedAt) || !durationMatch) return null;

  const durationAmount = Number(durationMatch[1]);
  const durationUnit = durationMatch[2];
  const durationMs = durationAmount * (durationUnit === 'D' ? 24 : 1) * 60 * 60 * 1000;
  const expiresAt = activatedAt * 1000 + durationMs;
  const remainingMs = Math.max(expiresAt - Date.now(), 0);

  return {
    name: normalizedName,
    activatedAt,
    duration,
    expiresAt,
    remainingMs,
    isActive: remainingMs > 0
  };
}

export function isInternationalOfferContext(params: { code?: string | null; offer?: string | null } = {}) {
  const parsedOffer = parseInternationalOffer(params.offer);
  return INTERNATIONAL_OFFER_ENABLED && isInternationalContextCode(params.code) && !!parsedOffer?.isActive;
}

export function getInternationalOfferCheckoutItems() {
  return [
    {
      product_id: INTERNATIONAL_AREA_PRODUCT_ID,
      price_id: INTERNATIONAL_AREA_PRICE_ID,
      quantity: 4
    },
    {
      product_id: INTERNATIONAL_TRAINING_PRODUCT_ID,
      price_id: INTERNATIONAL_TRAINING_PRICE_ID,
      quantity: 1
    }
  ];
}

export function getInternationalOfferCheckoutAreas() {
  return INTERNATIONAL_OFFER_AREAS;
}
